<template>
  <div class="weightlessness-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F_N = m(g ± a)$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：电梯中的读数 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 电梯井 -->
            <rect x="150" y="20" width="100" height="180" fill="none" stroke="#555" stroke-dasharray="4,4" />
            
            <!-- 电梯箱 -->
            <rect x="155" :y="elevatorY" width="90" height="60" fill="rgba(255,255,255,0.05)" stroke="#00d2ff" stroke-width="2" />
            
            <!-- 人/物体 -->
            <circle cx="200" :cy="elevatorY + 45" r="10" fill="#ff4757" />
            
            <!-- 弹簧秤读数 -->
            <text x="260" :y="elevatorY + 30" fill="#ffd700" font-size="12">视重: {{ apparentWeight.toFixed(1) }} N</text>
            
            <!-- 加速度箭头 -->
            <g v-if="Math.abs(accel) > 0.1">
                <path :d="accel > 0 ? 'M 130 150 L 130 100' : 'M 130 100 L 130 150'" 
                  stroke="#2ed573" stroke-width="4" marker-end="url(#arr-acc)" />
                <text x="110" y="125" fill="#2ed573" font-size="10" text-anchor="end">{{ accel > 0 ? '超重 (a↑)' : '失重 (a↓)' }}</text>
            </g>
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>视重 / 真实重力</label>
               <span class="val">{{ (apparentWeight / 100).toFixed(2) }} g</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col-full">
                  <label>调节运行加速度 a (m/s²)</label>
                  <el-slider v-model="accel" :min="-10" :max="10" :step="0.5" size="mini"></el-slider>
               </div>
            </div>
         </div>

         <div class="discovery-box">
            <p><strong>物理规律：</strong>物体的<strong>视重</strong>取决于支持力。当加速度向<strong>上</strong>时，支持力大于重力（<strong>超重</strong>）；加速度向<strong>下</strong>时，支持力小于重力（<strong>失重</strong>）。完全失去支持力即为<strong>完全失重</strong> (a = g ↓)。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WeightlessnessViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      accel: 0,
      elevatorY: 80,
      t: 0
    }
  },
  computed: {
    apparentWeight() {
       // m = 10kg, g = 10
       return 10 * (10 + this.accel);
    }
  },
  mounted() {
     this.timer = setInterval(() => {
        // Just vertical oscillation to visualize movement
        if(Math.abs(this.accel) > 0.1) {
           this.t += 0.05;
           this.elevatorY = 80 + Math.sin(this.t) * 10;
        }
     }, 30);
  },
  beforeDestroy() { clearInterval(this.timer); }
}
</script>

<style scoped lang="scss">
.weightlessness-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; .val { font-family: monospace; color: #ff4757; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { .col-full { label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } } }
.discovery-box { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
